export const disclaimer =
  "Disclaimer: Epione & Dr. Simon Ourian make no warranties  or representations that the information contained on this website is in every respect accurate or complete, and is not responsible for any errors or omissions or for the results obtained from the use of such. The information available on this website is not intended as a substitute for or to be used in lieu of professional medical advice or in person consultation. You are encouraged to confirm the information contained here with other sources. Always consult your physician or other qualified health care provider for medical advice and treatment. The creators, distributors, producers, and participants of this email disclaim any liability or loss in connection with the content provided here. </br> In many instances, the information available through this website and affiliated websites represents the opinions and judgments of the respective information provider. While Epione makes every effort to provide accurate and reliable information, we neither endorse nor are responsible for the accuracy or reliability of any opinion, advice or statement made on this website and affiliated websites by anyone other than authorized Epione employee spokespersons acting in their official capacities. Reliance on any information provided on this website, the contributors to this website, or other visitors to the website is solely at your own risk. We reserve the right to change or discontinue at any time any aspect or feature of this website. Also note that while epione.com frequently updates its contents, medical information changes rapidly. Therefore, some information may be out of date.";

export const MAPFEMALEFRONT = {
  name: "my-Femalemap",
  areas: [
    {
      name: "abdomen",
      shape: "poly",
      coords: [
        145, 223, 139, 231, 135, 239, 131, 246, 128, 255, 126, 262, 125, 269,
        123, 275, 122, 282, 120, 291, 118, 299, 118, 308, 118, 315, 118, 324,
        118, 334, 119, 340, 121, 345, 127, 340, 133, 333, 139, 326, 146, 323,
        152, 323, 160, 328, 164, 333, 169, 337, 173, 342, 179, 344, 184, 338,
        186, 329, 186, 318, 185, 308, 183, 298, 180, 288, 179, 278, 177, 269,
        173, 257, 169, 248, 164, 238, 158, 230, 152, 222, 148, 216,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "chest",
      shape: "poly",
      coords: [
        94, 175, 93, 183, 93, 190, 93, 195, 93, 201, 92, 207, 92, 213, 94, 219,
        96, 225, 100, 228, 105, 230, 110, 231, 116, 231, 122, 228, 127, 224,
        132, 220, 136, 213, 140, 205, 142, 197, 145, 186, 147, 194, 150, 200,
        152, 205, 154, 210, 158, 216, 163, 220, 168, 223, 174, 228, 178, 230,
        186, 231, 193, 229, 198, 224, 202, 217, 204, 209, 202, 199, 200, 192,
        199, 184, 196, 176, 194, 169, 191, 161, 188, 156, 174, 154, 154, 154,
        131, 155, 107, 156, 98, 159, 96, 166,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "neck",
      shape: "poly",
      coords: [
        124, 96, 126, 104, 126, 112, 125, 117, 122, 122, 119, 125, 112, 129,
        107, 131, 99, 133, 92, 135, 85, 136, 96, 138, 104, 138, 110, 139, 116,
        139, 122, 139, 129, 140, 135, 140, 141, 140, 147, 140, 155, 139, 165,
        139, 175, 138, 184, 136, 194, 135, 200, 133, 190, 129, 184, 126, 176,
        123, 170, 118, 167, 111, 166, 103, 168, 94, 164, 101, 158, 106, 148,
        109, 140, 109, 133, 106, 128, 102,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "jaw",
      shape: "poly",
      coords: [
        118, 80, 119, 87, 122, 92, 127, 98, 132, 101, 138, 104, 145, 105, 152,
        104, 158, 101, 163, 96, 168, 92, 172, 86, 173, 77, 168, 78, 166, 86,
        158, 93, 151, 98, 144, 99, 134, 96, 126, 88, 122, 80,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "lips",
      shape: "poly",
      coords: [
        134, 86, 138, 90, 143, 91, 149, 90, 155, 89, 158, 84, 154, 81, 148, 80,
        142, 81, 135, 83,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "nose",
      shape: "poly",
      coords: [
        140, 65, 137, 71, 137, 73, 137, 76, 138, 79, 144, 79, 148, 79, 151, 75,
        149, 69, 147, 60, 146, 52, 140, 52, 140, 59, 140, 64,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "eyes",
      shape: "poly",
      coords: [
        117, 54, 123, 50, 129, 48, 135, 48, 140, 51, 144, 52, 150, 48, 157, 46,
        162, 46, 167, 49, 171, 53, 169, 59, 164, 61, 157, 62, 150, 62, 143, 60,
        136, 60, 130, 62, 124, 62, 119, 60, 116, 56,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "cheeks",
      shape: "poly",
      coords: [
        151, 60, 150, 66, 152, 72, 154, 77, 158, 81, 163, 78, 168, 73, 172, 68,
        174, 61, 172, 55, 166, 60, 158, 62,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "cheeks",
      shape: "poly",
      coords: [
        137, 61, 137, 67, 136, 72, 135, 77, 132, 81, 125, 83, 119, 80, 117, 74,
        116, 66, 116, 59, 123, 64, 130, 64,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "forehead",
      shape: "poly",
      coords: [
        113, 51, 118, 47, 124, 45, 129, 43, 136, 42, 143, 42, 149, 42, 156, 41,
        164, 42, 170, 44, 178, 48, 177, 41, 176, 34, 168, 32, 158, 31, 150, 31,
        142, 31, 133, 31, 127, 32, 120, 35, 114, 39,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "head",
      shape: "poly",
      coords: [
        114, 36, 120, 33, 127, 32, 133, 30, 140, 29, 146, 30, 152, 30, 158, 30,
        164, 30, 170, 31, 176, 35, 174, 27, 170, 20, 164, 15, 159, 11, 153, 10,
        146, 9, 138, 9, 132, 11, 126, 15, 121, 18, 116, 27,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "ears",
      shape: "poly",
      coords: [
        174, 78, 176, 70, 178, 62, 177, 55, 183, 56, 184, 61, 183, 68, 182, 74,
        179, 79,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "ears",
      shape: "poly",
      coords: [
        117, 79, 116, 72, 114, 64, 114, 58, 109, 56, 108, 61, 109, 56, 108, 67,
        109, 72, 113, 78,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "sidefat",
      shape: "poly",
      coords: [
        111, 353, 106, 345, 102, 339, 97, 332, 92, 336, 87, 341, 82, 351, 81,
        343, 85, 331, 87, 322, 89, 314, 92, 307, 95, 301, 98, 293, 100, 285,
        103, 277, 103, 269, 101, 257, 98, 247, 97, 239, 94, 233, 94, 223, 100,
        228, 105, 231, 113, 232, 118, 231, 117, 244, 115, 252, 114, 260, 112,
        271, 111, 285, 109, 305, 109, 325,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "sidefat",
      shape: "poly",
      coords: [
        189, 349, 196, 343, 202, 337, 205, 333, 209, 340, 212, 343, 217, 350,
        217, 341, 214, 334, 213, 324, 209, 313, 206, 305, 202, 297, 198, 286,
        195, 275, 194, 266, 196, 257, 198, 246, 199, 237, 201, 229, 202, 221,
        197, 225, 192, 228, 185, 230, 177, 231, 180, 243, 182, 256, 184, 269,
        187, 288, 190, 313,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "thigs",
      shape: "poly",
      coords: [
        81, 356, 92, 370, 100, 376, 108, 381, 115, 384, 123, 390, 129, 392, 138,
        394, 144, 396, 145, 407, 145, 418, 144, 434, 143, 451, 142, 466, 143,
        488, 142, 500, 142, 508, 131, 505, 124, 504, 114, 505, 108, 507, 100,
        511, 94, 487, 88, 464, 82, 436, 78, 416, 77, 390,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "thigs",
      shape: "poly",
      coords: [
        217, 345, 207, 357, 202, 363, 196, 367, 189, 374, 178, 381, 168, 387,
        157, 392, 155, 403, 154, 419, 155, 431, 158, 446, 158, 458, 159, 468,
        160, 480, 159, 492, 160, 500, 160, 508, 167, 504, 175, 502, 183, 501,
        189, 501, 196, 505, 202, 509, 207, 485, 211, 465, 215, 450, 218, 434,
        221, 421, 223, 398, 222, 379,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "knees",
      shape: "poly",
      coords: [
        102, 521, 103, 533, 104, 536, 104, 540, 104, 558, 102, 577, 104, 593,
        106, 606, 110, 623, 113, 634, 116, 648, 119, 660, 122, 672, 123, 682,
        128, 680, 134, 677, 140, 678, 144, 682, 142, 666, 142, 646, 142, 630,
        144, 613, 145, 596, 143, 574, 140, 556, 140, 542, 143, 529, 143, 519,
        123, 508,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "knees",
      shape: "poly",
      coords: [
        158, 515, 159, 529, 164, 550, 162, 562, 160, 578, 159, 597, 160, 613,
        162, 628, 163, 644, 164, 658, 164, 674, 163, 684, 170, 682, 176, 679,
        180, 682, 183, 686, 185, 669, 187, 656, 191, 638, 194, 621, 197, 608,
        200, 591, 201, 570, 200, 556, 199, 546, 199, 534, 200, 524, 201, 511,
        178, 502,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "feets",
      shape: "poly",
      coords: [
        122, 684, 129, 686, 135, 685, 142, 684, 144, 680, 146, 692, 145, 699,
        146, 705, 147, 711, 145, 716, 142, 721, 142, 727, 142, 734, 139, 740,
        137, 745, 134, 751, 127, 751, 120, 753, 114, 750, 108, 746, 107, 738,
        113, 729, 118, 719, 122, 708, 123, 697,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "feets",
      shape: "poly",
      coords: [
        162, 680, 170, 682, 176, 682, 182, 682, 186, 678, 184, 689, 185, 698,
        187, 708, 190, 716, 194, 725, 197, 730, 200, 736, 202, 742, 201, 747,
        195, 749, 189, 753, 183, 752, 180, 753, 176, 753, 172, 745, 167, 738,
        167, 726, 166, 718, 161, 714, 162, 702, 162, 691,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "hands",
      shape: "poly",
      coords: [
        88, 136, 88, 144, 88, 151, 88, 157, 90, 167, 93, 175, 94, 181, 94, 187,
        93, 196, 92, 203, 92, 209, 92, 215, 94, 223, 94, 229, 92, 240, 90, 252,
        86, 262, 84, 270, 80, 280, 78, 289, 77, 298, 75, 307, 73, 315, 72, 324,
        67, 336, 64, 344, 62, 352, 59, 360, 56, 368, 55, 374, 49, 367, 44, 363,
        37, 362, 42, 348, 45, 326, 47, 306, 48, 289, 51, 274, 57, 259, 61, 246,
        63, 228, 65, 213, 68, 198, 68, 187, 68, 176, 68, 166, 70, 157, 73, 147,
        79, 140,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "hands",
      shape: "poly",
      coords: [
        206, 136, 206, 144, 206, 152, 204, 159, 201, 168, 197, 174, 198, 182,
        200, 193, 201, 202, 204, 214, 203, 224, 202, 233, 201, 238, 202, 244,
        208, 261, 214, 277, 218, 288, 220, 298, 223, 311, 227, 325, 231, 335,
        234, 342, 237, 350, 240, 358, 242, 364, 245, 370, 251, 366, 258, 363,
        264, 360, 257, 342, 252, 320, 250, 308, 248, 292, 246, 280, 240, 264,
        236, 253, 234, 240, 231, 222, 227, 201, 227, 187, 227, 174, 226, 158,
        221, 149, 216, 141,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "palms",
      shape: "poly",
      coords: [
        36, 362, 28, 371, 20, 378, 17, 385, 10, 394, 7, 401, 9, 406, 14, 400,
        20, 394, 21, 399, 17, 406, 11, 421, 15, 424, 18, 419, 15, 424, 22, 411,
        26, 402, 29, 404, 25, 415, 21, 429, 24, 432, 27, 430, 30, 420, 32, 411,
        34, 405, 37, 407, 36, 419, 34, 427, 38, 431, 40, 426, 38, 431, 42, 417,
        44, 408, 46, 407, 46, 414, 46, 424, 49, 425, 51, 415, 51, 404, 52, 396,
        53, 389, 56, 382, 56, 374, 57, 367, 45, 367,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "palms",
      shape: "poly",
      coords: [
        243, 366, 245, 376, 247, 390, 249, 401, 249, 410, 251, 418, 251, 424,
        255, 425, 253, 411, 253, 404, 258, 406, 257, 416, 260, 426, 263, 431,
        266, 431, 265, 422, 264, 414, 261, 402, 264, 406, 268, 416, 271, 424,
        274, 431, 277, 432, 278, 429, 275, 419, 273, 411, 271, 402, 273, 401,
        278, 409, 281, 416, 284, 423, 288, 424, 288, 417, 284, 409, 280, 400,
        278, 392, 276, 385, 283, 394, 288, 400, 293, 401, 296, 399, 296, 397,
        290, 391, 285, 384, 281, 377, 275, 370, 266, 362, 262, 356, 253, 362,
      ],
      fillColor: "#6ec7d38e",
    },
  ],
};
export const MAPMALEFRONT = {
  name: "my-map",
  areas: [
    {
      name: "abdomen",
      shape: "poly",
      coords: [
        164, 215, 129, 236, 128, 306, 148, 320, 154, 345, 176, 344, 183, 321,
        201, 306, 200, 235, 183, 226,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "cheeks",
      shape: "poly",
      coords: [
        159, 52, 151, 55, 142, 55, 134, 51, 135, 58, 136, 63, 141, 70, 147, 71,
        155, 69, 159, 63,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "cheeks",
      shape: "poly",
      coords: [
        170, 50, 173, 56, 174, 62, 174, 67, 174, 71, 185, 67, 190, 64, 193, 58,
        195, 50, 195, 44, 188, 50, 179, 53,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "thigs",
      shape: "poly",
      coords: [
        96, 402, 96, 419, 98, 444, 101, 466, 105, 487, 108, 503, 119, 509, 129,
        511, 137, 511, 145, 511, 152, 510, 154, 506, 158, 483, 160, 461, 162,
        441, 162, 423, 157, 402, 150, 379, 141, 365, 132, 356, 120, 340, 106,
        327, 102, 335, 100, 350, 99, 364, 98, 380,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "thigs",
      shape: "poly",
      coords: [
        173, 404, 170, 418, 169, 447, 171, 467, 173, 487, 176, 503, 187, 509,
        197, 511, 205, 511, 213, 511, 220, 510, 222, 506, 226, 483, 230, 464,
        233, 444, 235, 425, 234, 403, 232, 379, 231, 361, 230, 345, 227, 333,
        213, 340, 202, 350, 192, 362, 184, 375, 178, 389,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "eyes",
      shape: "poly",
      coords: [
        136, 45, 141, 50, 147, 52, 153, 53, 159, 53, 163, 48, 169, 52, 177, 53,
        187, 52, 195, 45, 191, 39, 182, 37, 174, 38, 165, 41, 159, 39, 150, 37,
        144, 38, 139, 40,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "knees",
      shape: "poly",
      coords: [
        108, 506, 120, 503, 127, 504, 133, 503, 140, 503, 148, 503, 155, 505,
        153, 521, 153, 532, 152, 539, 150, 545, 147, 552, 146, 558, 145, 566,
        147, 577, 149, 588, 149, 598, 147, 608, 147, 615, 145, 623, 144, 632,
        143, 640, 142, 648, 141, 655, 141, 662, 140, 670, 130, 668, 122, 669,
        118, 673, 116, 653, 116, 662, 113, 644, 111, 632, 110, 617, 108, 606,
        106, 594, 105, 581, 105, 567, 108, 558, 110, 546, 109, 531, 108, 516,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "knees",
      shape: "poly",
      coords: [
        176, 504, 186, 504, 196, 503, 205, 504, 217, 504, 222, 504, 221, 517,
        219, 528, 219, 541, 220, 549, 223, 559, 223, 574, 223, 594, 222, 606,
        220, 619, 217, 631, 215, 643, 213, 657, 213, 670, 212, 684, 204, 681,
        197, 681, 189, 685, 188, 670, 189, 659, 187, 640, 185, 630, 184, 618,
        182, 604, 181, 591, 181, 579, 183, 569, 184, 558, 181, 547, 177, 534,
        176, 517,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "feets",
      shape: "poly",
      coords: [
        189, 675, 187, 689, 188, 696, 188, 702, 188, 709, 188, 716, 192, 721,
        195, 727, 195, 733, 196, 740, 199, 746, 202, 751, 206, 755, 212, 754,
        217, 755, 222, 753, 225, 749, 229, 747, 233, 743, 231, 736, 225, 727,
        220, 720, 216, 712, 214, 704, 213, 696, 214, 690, 212, 683, 212, 676,
        203, 678, 195, 679, 189, 676,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "feets",
      shape: "poly",
      coords: [
        189, 675, 187, 689, 188, 696, 188, 702, 188, 709, 188, 716, 192, 721,
        195, 727, 195, 733, 196, 740, 199, 746, 202, 751, 206, 755, 212, 754,
        217, 755, 222, 753, 225, 749, 229, 747, 233, 743, 231, 736, 225, 727,
        220, 720, 216, 712, 214, 704, 213, 696, 214, 690, 212, 683, 212, 676,
        203, 678, 195, 679, 189, 676,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "feets",
      shape: "poly",
      coords: [
        116, 688, 116, 696, 117, 704, 112, 715, 107, 725, 100, 734, 98, 741, 97,
        748, 102, 751, 111, 754, 122, 755, 129, 751, 134, 742, 135, 734, 137,
        724, 141, 719, 143, 711, 141, 701, 143, 694, 141, 686, 135, 689, 128,
        690, 121, 690,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "hands",
      shape: "poly",
      coords: [
        85, 137, 87, 143, 87, 151, 89, 159, 92, 166, 96, 174, 98, 182, 100, 189,
        100, 199, 99, 207, 99, 214, 99, 220, 101, 227, 99, 234, 96, 242, 93,
        252, 91, 263, 91, 273, 88, 283, 86, 296, 82, 309, 80, 317, 78, 326, 75,
        334, 72, 340, 72, 349, 69, 360, 66, 368, 61, 372, 54, 368, 45, 365, 43,
        365, 45, 351, 48, 337, 50, 325, 49, 311, 49, 294, 52, 277, 55, 265, 61,
        251, 65, 230, 67, 209, 69, 195, 69, 181, 69, 170, 70, 159, 73, 151, 77,
        145,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "palms",
      shape: "poly",
      coords: [
        41, 366, 35, 370, 29, 374, 23, 378, 19, 382, 16, 387, 11, 391, 5, 396,
        6, 402, 11, 401, 17, 397, 22, 392, 27, 391, 27, 397, 26, 403, 24, 409,
        21, 416, 20, 422, 17, 428, 15, 435, 20, 438, 24, 432, 27, 424, 31, 418,
        34, 410, 35, 416, 33, 425, 33, 432, 31, 438, 29, 444, 31, 446, 35, 446,
        37, 439, 39, 432, 41, 425, 42, 418, 43, 412, 46, 418, 45, 425, 44, 432,
        44, 439, 44, 443, 45, 446, 48, 444, 49, 437, 51, 430, 53, 424, 53, 417,
        55, 412, 56, 418, 56, 426, 55, 432, 56, 434, 59, 435, 61, 430, 61, 424,
        63, 417, 62, 409, 63, 402, 64, 394, 65, 386, 65, 377, 65, 370, 53, 370,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "palms",
      shape: "poly",
      coords: [
        266, 368, 267, 374, 268, 382, 269, 390, 269, 396, 270, 402, 271, 408,
        271, 414, 272, 419, 272, 424, 273, 430, 277, 434, 279, 430, 277, 421,
        276, 414, 277, 411, 281, 416, 282, 426, 283, 432, 285, 437, 286, 442,
        288, 444, 292, 443, 290, 434, 289, 430, 290, 434, 288, 421, 288, 413,
        291, 415, 292, 422, 293, 428, 296, 433, 296, 441, 299, 444, 303, 446,
        305, 443, 303, 434, 301, 426, 300, 418, 297, 410, 302, 415, 305, 420,
        302, 415, 307, 425, 309, 430, 312, 435, 315, 438, 316, 437, 318, 433,
        314, 425, 312, 417, 309, 410, 307, 403, 306, 396, 305, 389, 307, 388,
        313, 392, 317, 396, 322, 399, 327, 400, 329, 396, 325, 391, 318, 385,
        313, 380, 307, 374, 301, 370, 294, 366, 290, 361, 280, 366,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "hands",
      shape: "poly",
      coords: [
        247, 138, 243, 146, 241, 155, 239, 161, 237, 169, 234, 175, 232, 182,
        230, 188, 229, 195, 229, 201, 229, 210, 229, 217, 229, 225, 231, 232,
        233, 237, 235, 244, 237, 251, 239, 257, 241, 265, 239, 273, 241, 279,
        243, 285, 244, 293, 246, 301, 249, 310, 253, 320, 255, 327, 256, 333,
        258, 342, 261, 348, 263, 357, 265, 365, 267, 372, 269, 378, 274, 369,
        279, 366, 285, 363, 291, 364, 285, 347, 283, 330, 283, 315, 282, 299,
        281, 284, 276, 265, 270, 250, 266, 238, 266, 219, 262, 202, 262, 186,
        261, 172, 260, 162, 257, 154, 254, 146,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "forehead",
      shape: "poly",
      coords: [
        133, 40, 139, 36, 145, 33, 152, 33, 159, 31, 165, 31, 171, 31, 177, 31,
        184, 31, 190, 33, 196, 36, 196, 25, 189, 21, 180, 19, 170, 19, 162, 19,
        153, 20, 145, 22, 140, 25, 134, 27,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "head",
      shape: "poly",
      coords: [
        134, 28, 141, 23, 148, 21, 152, 20, 159, 19, 167, 19, 176, 19, 185, 21,
        196, 27, 192, 16, 184, 7, 177, 3, 169, 1, 161, 1, 155, 3, 147, 7, 142,
        11, 137, 19,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "sidefat",
      shape: "poly",
      coords: [
        105, 234, 101, 217, 109, 219, 114, 221, 120, 224, 123, 230, 122, 235,
        124, 284, 124, 303, 132, 351, 115, 338, 102, 332, 107, 314, 109, 293,
        110, 265, 107, 249,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "sidefat",
      shape: "poly",
      coords: [
        228, 209, 213, 216, 200, 217, 203, 226, 205, 237, 204, 247, 204, 258,
        203, 270, 203, 283, 204, 302, 204, 320, 204, 338, 215, 320, 223, 310,
        219, 282, 220, 264, 223, 249, 226, 231,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "chest",
      shape: "poly",
      coords: [
        109, 157, 101, 168, 102, 182, 104, 193, 108, 204, 119, 211, 131, 212,
        140, 210, 151, 206, 156, 199, 160, 192, 167, 193, 172, 200, 178, 206,
        188, 209, 197, 209, 204, 210, 213, 209, 220, 205, 225, 197, 227, 188,
        227, 177, 226, 166, 223, 158, 213, 152, 191, 151, 170, 150, 157, 150,
        143, 150, 128, 150, 116, 152,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "ears",
      shape: "poly",
      coords: [134, 51, 131, 47, 128, 50, 127, 59, 128, 65, 134, 69, 134, 60],
      fillColor: "#6ec7d38e",
    },
    {
      name: "ears",
      shape: "poly",
      coords: [
        196, 51, 201, 47, 203, 52, 204, 57, 203, 62, 200, 67, 194, 71, 195, 60,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "neck",
      shape: "poly",
      coords: [
        102, 130, 110, 132, 118, 134, 126, 135, 134, 135, 140, 137, 148, 137,
        159, 137, 165, 138, 173, 138, 181, 137, 188, 136, 196, 136, 203, 135,
        209, 134, 217, 133, 226, 131, 231, 131, 216, 126, 205, 120, 195, 115,
        188, 107, 187, 99, 188, 91, 180, 95, 170, 97, 160, 97, 152, 95, 146, 92,
        142, 89, 142, 98, 143, 104, 143, 109, 140, 114, 130, 119, 122, 122, 116,
        125, 111, 127,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "jaw",
      shape: "poly",
      coords: [
        137, 74, 139, 81, 142, 86, 146, 90, 151, 95, 160, 97, 170, 98, 178, 95,
        185, 91, 190, 84, 192, 76, 194, 72, 188, 71, 184, 79, 179, 84, 171, 86,
        162, 87, 154, 86, 148, 81, 144, 73,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "lips",
      shape: "poly",
      coords: [
        152, 78, 158, 82, 166, 82, 175, 82, 180, 77, 175, 71, 166, 71, 157, 71,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "nose",
      shape: "poly",
      coords: [
        162, 42, 162, 47, 162, 56, 161, 59, 160, 67, 166, 68, 172, 66, 171, 58,
        169, 52, 168, 41,
      ],
      fillColor: "#6ec7d38e",
    },
  ],
};

export const MAPMALEBACK = {
  name: "my-maleBackmap",
  areas: [
    {
      name: "head",
      shape: "poly",
      coords: [
        124, 40, 131, 33, 139, 31, 149, 29, 156, 29, 167, 30, 172, 30, 178, 32,
        183, 33, 188, 36, 191, 38, 190, 26, 186, 16, 179, 8, 172, 4, 165, 1,
        155, 0, 143, 4, 135, 9, 129, 17, 125, 25,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "ears",
      shape: "poly",
      coords: [
        125, 50, 118, 48, 117, 56, 118, 62, 120, 68, 123, 72, 127, 77, 128, 73,
        125, 62,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "ears",
      shape: "poly",
      coords: [
        189, 62, 188, 68, 186, 74, 191, 73, 195, 68, 196, 60, 197, 53, 198, 47,
        193, 50, 191, 54,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "neck",
      shape: "poly",
      coords: [
        109, 126, 122, 129, 133, 133, 147, 137, 152, 139, 157, 142, 158, 142,
        167, 138, 176, 134, 183, 132, 193, 128, 201, 124, 193, 119, 185, 113,
        181, 101, 182, 92, 172, 96, 162, 97, 152, 98, 142, 97, 133, 93, 135,
        101, 133, 110, 127, 115, 120, 120,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "hands",
      shape: "poly",
      coords: [
        93, 132, 91, 143, 88, 154, 85, 163, 84, 177, 85, 189, 90, 197, 91, 204,
        93, 214, 92, 222, 92, 230, 88, 239, 85, 247, 83, 257, 80, 265, 80, 276,
        80, 284, 78, 291, 74, 316, 68, 332, 64, 343, 60, 358, 58, 370, 57, 377,
        56, 383, 49, 380, 42, 376, 34, 373, 32, 371, 36, 360, 37, 336, 38, 309,
        39, 291, 41, 280, 48, 265, 51, 252, 51, 231, 55, 208, 55, 191, 56, 171,
        60, 155, 65, 146, 75, 137,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "hands",
      shape: "poly",
      coords: [
        221, 131, 223, 140, 225, 147, 227, 154, 230, 162, 229, 169, 229, 178,
        227, 187, 225, 194, 224, 206, 222, 219, 222, 230, 229, 247, 232, 262,
        234, 272, 235, 283, 237, 301, 242, 320, 247, 336, 251, 353, 254, 367,
        257, 379, 257, 381, 262, 376, 268, 373, 274, 371, 279, 369, 280, 367,
        276, 344, 275, 323, 276, 311, 275, 296, 273, 281, 266, 261, 263, 246,
        262, 226, 260, 214, 259, 197, 259, 184, 259, 171, 255, 159, 252, 149,
        245, 141, 234, 135,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "palms",
      shape: "poly",
      coords: [
        31, 370, 23, 375, 13, 383, 5, 389, 1, 395, 0, 401, 6, 400, 12, 395, 18,
        392, 19, 398, 17, 408, 15, 415, 12, 424, 9, 432, 10, 437, 15, 434, 18,
        426, 21, 417, 25, 412, 25, 421, 24, 428, 23, 436, 22, 442, 24, 447, 27,
        442, 29, 436, 31, 430, 33, 422, 35, 415, 38, 421, 36, 428, 35, 437, 37,
        442, 41, 442, 42, 435, 44, 427, 44, 418, 47, 412, 48, 422, 48, 431, 51,
        434, 53, 429, 53, 421, 53, 413, 54, 405, 55, 396, 56, 388, 55, 375, 48,
        375, 39, 373,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "palms",
      shape: "poly",
      coords: [
        257, 377, 255, 391, 256, 400, 257, 407, 259, 417, 257, 423, 257, 430,
        260, 434, 263, 428, 264, 419, 265, 411, 268, 423, 268, 431, 269, 437,
        271, 443, 276, 441, 275, 430, 274, 421, 273, 413, 277, 417, 279, 433,
        281, 438, 282, 444, 287, 446, 289, 438, 286, 428, 284, 419, 284, 412,
        289, 421, 293, 427, 297, 435, 300, 439, 301, 431, 297, 420, 295, 410,
        293, 400, 292, 391, 297, 395, 303, 398, 309, 401, 313, 395, 307, 390,
        299, 384, 295, 379, 285, 374, 280, 369, 267, 375,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "buttocks",
      shape: "poly",
      coords: [
        87, 429, 227, 428, 228, 413, 227, 393, 225, 375, 224, 360, 222, 347,
        220, 337, 218, 327, 96, 327, 92, 347, 90, 365, 88, 386, 87, 400, 87,
        414,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "thigs",
      shape: "poly",
      coords: [
        154, 415, 145, 421, 131, 424, 117, 424, 105, 421, 97, 419, 90, 415, 87,
        413, 87, 426, 89, 449, 92, 468, 96, 491, 97, 502, 99, 519, 99, 531, 99,
        540, 105, 537, 115, 534, 125, 533, 133, 535, 139, 538, 146, 544, 147,
        527, 147, 513, 150, 499, 152, 483, 155, 458, 155, 434,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "thigs",
      shape: "poly",
      coords: [
        161, 414, 169, 421, 179, 425, 184, 425, 193, 425, 205, 422, 215, 418,
        221, 414, 227, 410, 227, 423, 227, 436, 223, 451, 223, 465, 221, 478,
        218, 494, 216, 507, 216, 518, 215, 526, 215, 536, 215, 544, 201, 538,
        196, 537, 189, 536, 179, 539, 170, 545, 169, 532, 168, 522, 166, 503,
        165, 492, 163, 473, 161, 456, 159, 441, 159, 427,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "knees",
      shape: "poly",
      coords: [
        99, 541, 105, 537, 119, 534, 128, 533, 137, 537, 145, 543, 144, 553,
        141, 564, 138, 574, 139, 586, 140, 600, 141, 609, 141, 624, 139, 638,
        137, 651, 135, 663, 134, 674, 133, 693, 132, 702, 133, 707, 125, 705,
        119, 705, 113, 706, 110, 706, 106, 687, 102, 664, 98, 640, 96, 623, 95,
        603, 97, 586, 100, 569, 100, 554,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "knees",
      shape: "poly",
      coords: [
        169, 544, 180, 539, 192, 537, 202, 539, 212, 543, 215, 547, 215, 565,
        218, 590, 219, 604, 219, 624, 217, 640, 213, 656, 210, 670, 209, 682,
        207, 692, 205, 700, 205, 704, 197, 705, 189, 703, 182, 703, 182, 692,
        181, 680, 181, 671, 179, 657, 176, 644, 174, 634, 173, 625, 173, 614,
        174, 604, 177, 592, 177, 582, 177, 574, 173, 560,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "feets",
      shape: "poly",
      coords: [
        109, 705, 107, 713, 102, 713, 97, 716, 92, 721, 93, 725, 95, 732, 99,
        736, 103, 741, 107, 746, 112, 751, 118, 754, 124, 754, 129, 752, 133,
        748, 134, 740, 133, 733, 133, 727, 133, 720, 135, 714, 133, 707, 121,
        704,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "feets",
      shape: "poly",
      coords: [
        182, 703, 180, 711, 180, 719, 181, 724, 181, 731, 181, 738, 181, 744,
        183, 750, 192, 754, 197, 754, 202, 751, 205, 746, 209, 742, 212, 738,
        217, 734, 219, 730, 221, 724, 222, 718, 220, 717, 215, 714, 214, 710,
        209, 714, 208, 711, 208, 708, 206, 704, 195, 703,
      ],
      fillColor: "#6ec7d38e",
    },
  ],
};

export const MAPFEMALEBACK = {
  name: "my-femaleBackmap",
  areas: [
    {
      name: "head",
      shape: "poly",
      coords: [
        112, 41, 121, 36, 131, 35, 140, 35, 148, 35, 155, 36, 161, 37, 168, 38,
        174, 40, 177, 42, 174, 33, 170, 24, 164, 17, 156, 13, 146, 11, 136, 11,
        127, 15, 119, 21, 115, 27,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "ears",
      shape: "poly",
      coords: [
        112, 58, 113, 65, 114, 71, 116, 77, 117, 81, 110, 78, 106, 67, 105, 61,
        106, 56,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "ears",
      shape: "poly",
      coords: [
        175, 57, 181, 54, 182, 59, 182, 66, 179, 72, 177, 79, 173, 79, 175, 65,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "neck",
      shape: "poly",
      coords: [
        100, 128, 119, 130, 141, 130, 150, 130, 164, 129, 182, 127, 174, 123,
        166, 116, 164, 106, 166, 98, 170, 90, 154, 95, 137, 95, 119, 89, 122,
        100, 122, 109, 120, 117, 112, 123,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "neck",
      shape: "poly",
      coords: [
        100, 128, 119, 130, 141, 130, 150, 130, 164, 129, 182, 127, 174, 123,
        166, 116, 164, 106, 166, 98, 170, 90, 154, 95, 137, 95, 119, 89, 122,
        100, 122, 109, 120, 117, 112, 123,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "buttocks",
      shape: "poly",
      coords: [
        73, 409, 218, 407, 218, 391, 216, 373, 213, 354, 211, 339, 207, 325,
        204, 317, 83, 318, 80, 332, 77, 346, 74, 370, 72, 390,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "thigs",
      shape: "poly",
      coords: [
        72, 406, 82, 410, 90, 412, 100, 412, 110, 412, 120, 410, 129, 406, 134,
        402, 138, 395, 140, 408, 140, 424, 138, 442, 137, 455, 136, 464, 136,
        477, 136, 490, 136, 507, 136, 518, 137, 530, 129, 526, 121, 525, 112,
        525, 104, 525, 96, 529, 94, 517, 90, 498, 86, 477, 79, 453, 74, 425,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "thigs",
      shape: "poly",
      coords: [
        151, 398, 162, 405, 169, 407, 180, 410, 186, 410, 196, 409, 202, 407,
        210, 405, 218, 398, 216, 416, 213, 434, 210, 454, 203, 480, 201, 491,
        199, 502, 197, 512, 196, 520, 195, 528, 182, 524, 172, 523, 164, 523,
        154, 526, 154, 512, 154, 496, 155, 479, 153, 467, 152, 451, 150, 439,
        148, 421, 149, 407,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "knees",
      shape: "poly",
      coords: [
        95, 529, 97, 546, 96, 559, 96, 573, 95, 588, 94, 598, 95, 613, 98, 624,
        101, 639, 105, 654, 108, 666, 111, 682, 113, 694, 114, 704, 113, 713,
        120, 711, 128, 710, 133, 711, 138, 714, 135, 699, 134, 688, 134, 676,
        135, 664, 135, 650, 136, 634, 137, 622, 138, 609, 138, 597, 136, 587,
        135, 575, 132, 564, 133, 555, 136, 543, 136, 532, 118, 525,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "knees",
      shape: "poly",
      coords: [
        153, 525, 155, 544, 158, 563, 157, 578, 154, 597, 153, 608, 154, 621,
        155, 644, 156, 663, 157, 673, 157, 686, 156, 696, 155, 706, 154, 712,
        161, 708, 168, 706, 173, 706, 178, 710, 179, 693, 182, 675, 186, 656,
        192, 634, 196, 610, 196, 595, 196, 580, 194, 563, 194, 547, 194, 536,
        195, 528, 176, 522,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "feets",
      shape: "poly",
      coords: [
        112, 712, 105, 715, 100, 719, 102, 725, 106, 730, 112, 735, 115, 740,
        120, 744, 126, 746, 132, 744, 136, 741, 138, 734, 138, 727, 137, 719,
        138, 714, 128, 710,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "feets",
      shape: "poly",
      coords: [
        154, 712, 154, 720, 153, 728, 153, 734, 154, 742, 158, 746, 164, 747,
        169, 746, 172, 742, 177, 738, 183, 733, 185, 728, 189, 723, 192, 718,
        187, 714, 180, 712, 174, 708, 163, 707,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "hands",
      shape: "poly",
      coords: [
        92, 131, 89, 143, 86, 153, 86, 162, 89, 172, 89, 178, 90, 185, 90, 196,
        90, 205, 91, 214, 92, 223, 92, 232, 88, 244, 85, 253, 82, 265, 77, 276,
        74, 289, 72, 299, 71, 310, 66, 325, 61, 341, 55, 352, 52, 364, 46, 372,
        39, 368, 29, 364, 32, 354, 35, 347, 38, 335, 41, 323, 43, 310, 43, 297,
        44, 286, 48, 275, 52, 265, 56, 250, 57, 238, 62, 218, 64, 201, 63, 189,
        63, 176, 64, 163, 67, 150, 71, 142, 76, 138, 84, 133,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "hands",
      shape: "poly",
      coords: [
        192, 131, 195, 139, 197, 147, 198, 154, 200, 165, 199, 172, 199, 180,
        198, 192, 197, 208, 196, 220, 200, 235, 203, 250, 209, 267, 213, 279,
        215, 289, 218, 305, 222, 319, 225, 330, 232, 348, 237, 363, 240, 371,
        246, 365, 251, 362, 256, 362, 261, 364, 255, 349, 251, 334, 248, 319,
        248, 306, 246, 289, 243, 277, 238, 265, 235, 253, 232, 241, 228, 222,
        227, 208, 225, 195, 226, 181, 226, 168, 224, 157, 220, 147, 214, 139,
        201, 133,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "palms",
      shape: "poly",
      coords: [
        49, 374, 38, 368, 28, 363, 24, 368, 18, 373, 13, 378, 9, 384, 6, 389, 4,
        394, 0, 400, 0, 406, 6, 400, 11, 394, 14, 388, 16, 393, 14, 400, 11,
        406, 8, 414, 5, 421, 5, 428, 10, 429, 11, 421, 14, 412, 18, 404, 22,
        408, 20, 415, 18, 422, 16, 429, 16, 436, 20, 437, 22, 430, 24, 423, 26,
        415, 28, 406, 31, 411, 31, 417, 29, 424, 30, 429, 31, 435, 35, 432, 35,
        423, 36, 414, 36, 406, 38, 401, 41, 405, 40, 412, 40, 420, 39, 424, 41,
        426, 46, 424, 45, 417, 45, 408, 45, 400, 47, 393, 48, 386, 50, 380,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "palms",
      shape: "poly",
      coords: [
        240, 371, 240, 379, 241, 385, 242, 393, 244, 399, 245, 406, 246, 413,
        246, 420, 247, 426, 250, 427, 252, 420, 251, 414, 250, 408, 252, 404,
        255, 408, 256, 417, 257, 426, 260, 432, 264, 436, 266, 434, 264, 425,
        262, 419, 261, 411, 259, 404, 266, 412, 267, 418, 268, 426, 270, 432,
        273, 435, 276, 436, 278, 435, 276, 427, 274, 420, 272, 413, 269, 405,
        266, 399, 272, 403, 274, 409, 278, 416, 282, 422, 286, 425, 286, 416,
        282, 409, 279, 403, 276, 396, 273, 390, 280, 398, 285, 403, 287, 399,
        286, 393, 281, 387, 277, 381, 272, 375, 268, 370, 263, 366, 258, 362,
        250, 363,
      ],
      fillColor: "#6ec7d38e",
    },
  ],
};

export const MAPMALEFRONTMB = {
  name: "my-map",
  areas: [
    {
      name: "chest",
      shape: "poly",
      coords: [
        67, 104, 64, 111, 66, 119, 66, 125, 66, 130, 69, 136, 74, 139, 80, 140,
        86, 140, 92, 139, 98, 137, 103, 134, 106, 129, 111, 131, 115, 134, 119,
        137, 125, 140, 132, 141, 138, 140, 144, 139, 148, 134, 150, 127, 151,
        119, 150, 112, 149, 105,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "abdomen",
      shape: "poly",
      coords: [
        110, 141, 86, 160, 85, 207, 99, 214, 102, 231, 115, 232, 120, 212, 134,
        208, 134, 159,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "sidefat",
      shape: "poly",
      coords: [
        67, 150, 70, 162, 72, 172, 72, 182, 71, 192, 71, 201, 70, 208, 76, 216,
        80, 220, 81, 211, 81, 200, 81, 186, 80, 173, 79, 162, 76, 150, 71, 141,
        68, 148,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "sidefat",
      shape: "poly",
      coords: [
        150, 140, 149, 150, 148, 161, 146, 169, 144, 178, 145, 185, 145, 194,
        146, 204, 143, 211, 138, 221, 138, 202, 137, 190, 137, 179, 138, 164,
        139, 153, 139, 143,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "thigs",
      shape: "poly",
      coords: [
        68, 216, 79, 225, 88, 234, 94, 243, 98, 252, 101, 258, 105, 267, 106,
        276, 106, 287, 105, 301, 103, 313, 102, 321, 101, 330, 89, 325, 81, 325,
        71, 330, 69, 317, 66, 302, 64, 291, 62, 277, 62, 262, 62, 250, 64, 235,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "thigs",
      shape: "poly",
      coords: [
        147, 208, 140, 217, 133, 225, 126, 235, 123, 242, 119, 248, 113, 259,
        110, 267, 110, 277, 110, 285, 111, 297, 112, 305, 114, 314, 114, 323,
        115, 328, 128, 322, 137, 322, 148, 327, 150, 313, 152, 303, 153, 294,
        154, 283, 155, 273, 155, 263, 155, 250, 154, 239, 151, 224,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "knees",
      shape: "poly",
      coords: [
        70, 330, 72, 341, 73, 354, 71, 366, 70, 376, 70, 388, 71, 398, 73, 410,
        74, 419, 75, 428, 77, 440, 78, 450, 86, 449, 93, 450, 92, 439, 94, 430,
        94, 419, 96, 408, 98, 397, 99, 389, 98, 379, 96, 370, 98, 361, 100, 353,
        101, 343, 101, 334, 93, 327, 80, 326,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "knees",
      shape: "poly",
      coords: [
        114, 329, 116, 340, 116, 348, 118, 358, 120, 363, 122, 369, 120, 378,
        119, 389, 120, 400, 122, 412, 124, 423, 124, 434, 124, 443, 124, 453,
        132, 452, 140, 450, 141, 439, 142, 428, 144, 415, 146, 402, 148, 391,
        147, 381, 147, 369, 146, 360, 145, 344, 145, 335, 146, 328, 139, 324,
        127, 323,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "feets",
      shape: "poly",
      coords: [
        65, 495, 64, 488, 68, 483, 71, 478, 74, 472, 77, 466, 76, 460, 78, 452,
        85, 449, 93, 450, 94, 458, 93, 465, 93, 472, 89, 478, 89, 485, 86, 491,
        83, 497, 74, 498,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "feets",
      shape: "poly",
      coords: [
        124, 453, 124, 463, 124, 469, 124, 475, 128, 478, 129, 484, 130, 492,
        135, 498, 141, 498, 146, 498, 150, 495, 154, 490, 150, 483, 145, 474,
        141, 467, 141, 459, 140, 450, 132, 451,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "hands",
      shape: "poly",
      coords: [
        64, 87, 63, 95, 64, 105, 65, 117, 66, 125, 68, 134, 68, 142, 65, 155,
        62, 164, 60, 172, 59, 181, 58, 189, 55, 200, 52, 212, 48, 224, 46, 234,
        43, 248, 37, 243, 27, 241, 31, 231, 32, 217, 32, 204, 32, 190, 35, 180,
        40, 172, 42, 164, 43, 153, 44, 138, 45, 127, 45, 111, 48, 100, 54, 91,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "hands",
      shape: "poly",
      coords: [
        154, 88, 155, 96, 154, 102, 152, 108, 150, 114, 150, 123, 150, 130, 151,
        141, 151, 148, 153, 157, 156, 165, 158, 176, 158, 182, 160, 190, 162,
        197, 164, 206, 168, 216, 171, 226, 174, 235, 176, 242, 177, 248, 183,
        242, 188, 240, 194, 240, 189, 232, 186, 223, 186, 214, 186, 205, 186,
        196, 185, 186, 182, 178, 178, 170, 176, 160, 175, 150, 173, 140, 171,
        126, 172, 118, 172, 110, 169, 99, 162, 90,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "palms",
      shape: "poly",
      coords: [
        26, 242, 14, 251, 1, 264, 5, 267, 11, 261, 17, 258, 17, 265, 16, 271,
        13, 279, 10, 289, 13, 290, 16, 283, 20, 275, 21, 273, 22, 277, 20, 287,
        20, 295, 23, 295, 28, 273, 29, 279, 29, 286, 29, 292, 31, 294, 33, 292,
        34, 285, 34, 277, 34, 273, 36, 277, 38, 282, 38, 286, 41, 287, 42, 281,
        42, 277, 42, 268, 42, 261, 43, 253, 43, 249, 36, 244,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "palms",
      shape: "poly",
      coords: [
        26, 242, 14, 251, 1, 264, 5, 267, 11, 261, 17, 258, 17, 265, 16, 271,
        13, 279, 10, 289, 13, 290, 16, 283, 20, 275, 21, 273, 22, 277, 20, 287,
        20, 295, 23, 295, 28, 273, 29, 279, 29, 286, 29, 292, 31, 294, 33, 292,
        34, 285, 34, 277, 34, 273, 36, 277, 38, 282, 38, 286, 41, 287, 42, 281,
        42, 277, 42, 268, 42, 261, 43, 253, 43, 249, 36, 244,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "palms",
      shape: "poly",
      coords: [
        177, 247, 177, 263, 179, 274, 179, 283, 181, 287, 183, 289, 183, 277,
        183, 271, 186, 277, 187, 285, 189, 292, 193, 295, 192, 289, 190, 281,
        189, 275, 190, 271, 194, 282, 195, 286, 198, 291, 200, 292, 202, 289,
        198, 277, 196, 271, 201, 276, 204, 282, 208, 288, 210, 285, 207, 278,
        204, 269, 201, 262, 202, 258, 208, 261, 212, 263, 216, 262, 214, 257,
        208, 254, 203, 249, 196, 243, 193, 239, 185, 241,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "neck",
      shape: "poly",
      coords: [
        93, 57, 94, 67, 91, 74, 85, 79, 79, 82, 70, 86, 64, 89, 73, 91, 82, 92,
        92, 92, 100, 92, 107, 92, 116, 92, 124, 91, 132, 90, 142, 88, 149, 87,
        136, 81, 130, 78, 124, 71, 124, 64, 125, 56, 112, 65, 102, 64,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "jaw",
      shape: "poly",
      coords: [
        90, 47, 92, 54, 96, 59, 100, 63, 106, 64, 113, 63, 119, 61, 125, 55,
        127, 49, 124, 49, 119, 55, 114, 57, 108, 58, 98, 57, 94, 48,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "lips",
      shape: "rect",
      coords: [101, 54, 116, 48],
      fillColor: "#6ec7d38e",
    },
    {
      name: "eyes",
      shape: "rect",
      coords: [92, 25, 127, 35],
      fillColor: "#6ec7d38e",
    },
    {
      name: "ears",
      shape: "rect",
      coords: [84, 32, 90, 49],
      fillColor: "#6ec7d38e",
    },
    {
      name: "ears",
      shape: "rect",
      coords: [135, 30, 129, 47],
      fillColor: "#6ec7d38e",
    },
    {
      name: "forehead",
      shape: "rect",
      coords: [88, 15, 130, 23],
      fillColor: "#6ec7d38e",
    },
    {
      name: "head",
      shape: "rect",
      coords: [88, 1, 130, 14],
      fillColor: "#6ec7d38e",
    },
    {
      name: "cheeks",
      shape: "rect",
      coords: [90, 35, 105, 47],
      fillColor: "#6ec7d38e",
    },
    {
      name: "cheeks",
      shape: "rect",
      coords: [113, 36, 129, 48],
      fillColor: "#6ec7d38e",
    },
    {
      name: "nose",
      shape: "rect",
      coords: [104, 31, 114, 46],
      fillColor: "#6ec7d38e",
    },
  ],
};

export const MAPMALEBACKMB = {
  name: "my-maleBackmap",
  areas: [
    {
      name: "buttocks",
      shape: "rect ",
      coords: [58, 230, 151, 284],
      fillColor: "#6ec7d38e",
    },
    {
      name: "thigs",
      shape: "rect ",
      coords: [59, 283, 103, 352],
      fillColor: "#6ec7d38e",
    },
    {
      name: "thigs",
      shape: "rect ",
      coords: [107, 283, 151, 352],
      fillColor: "#6ec7d38e",
    },
    {
      name: "knees",
      shape: "rect ",
      coords: [109, 353, 149, 465],
      fillColor: "#6ec7d38e",
    },
    {
      name: "knees",
      shape: "rect ",
      coords: [59, 354, 99, 466],
      fillColor: "#6ec7d38e",
    },
    {
      name: "feets",
      shape: "rect ",
      coords: [62, 465, 95, 499],
      fillColor: "#6ec7d38e",
    },
    {
      name: "feets",
      shape: "rect ",
      coords: [116, 465, 149, 499],
      fillColor: "#6ec7d38e",
    },
    {
      name: "hands",
      shape: "rect ",
      coords: [17, 85, 60, 244],
      fillColor: "#6ec7d38e",
    },
    {
      name: "hands",
      shape: "rect ",
      coords: [147, 87, 190, 246],
      fillColor: "#6ec7d38e",
    },
    {
      name: "palms",
      shape: "rect ",
      coords: [163, 248, 207, 295],
      fillColor: "#6ec7d38e",
    },
    {
      name: "palms",
      shape: "rect ",
      coords: [0, 247, 44, 294],
      fillColor: "#6ec7d38e",
    },
    {
      name: "neck",
      shape: "rect ",
      coords: [79, 52, 129, 79],
      fillColor: "#6ec7d38e",
    },
    {
      name: "head",
      shape: "rect ",
      coords: [83, 19, 127, 0],
      fillColor: "#6ec7d38e",
    },
    {
      name: "ears",
      shape: "rect ",
      coords: [125, 32, 131, 48],
      fillColor: "#6ec7d38e",
    },
    {
      name: "ears",
      shape: "rect ",
      coords: [80, 33, 86, 49],
      fillColor: "#6ec7d38e",
    },
  ],
};

export const MAPFEMALEFRONTMB = {
  name: "my-Femalemap",
  areas: [
    {
      name: "chest",
      shape: "rect ",
      coords: [59, 120, 136, 156],
      fillColor: "#6ec7d38e",
    },
    {
      name: "abdomen",
      shape: "rect ",
      coords: [76, 160, 122, 227],
      fillColor: "#6ec7d38e",
    },
    {
      name: "sidefat",
      shape: "rect ",
      coords: [61, 153, 76, 231],
      fillColor: "#6ec7d38e",
    },
    {
      name: "sidefat",
      shape: "rect ",
      coords: [123, 153, 138, 231],
      fillColor: "#6ec7d38e",
    },
    {
      name: "hands",
      shape: "rect ",
      coords: [57, 239, 25, 91],
      fillColor: "#6ec7d38e",
    },
    {
      name: "hands",
      shape: "rect ",
      coords: [137, 92, 174, 241],
      fillColor: "#6ec7d38e",
    },
    {
      name: "palms",
      shape: "rect ",
      coords: [5, 238, 39, 288],
      fillColor: "#6ec7d38e",
    },
    {
      name: "palms",
      shape: "rect ",
      coords: [158, 243, 197, 287, 197, 287],
      fillColor: "#6ec7d38e",
    },
    {
      name: "thigs",
      shape: "rect ",
      coords: [51, 246, 96, 337],
      fillColor: "#6ec7d38e",
    },
    {
      name: "thigs",
      shape: "rect ",
      coords: [103, 248, 148, 337],
      fillColor: "#6ec7d38e",
    },
    {
      name: "knees",
      shape: "rect ",
      coords: [65, 338, 98, 457],
      fillColor: "#6ec7d38e",
    },
    {
      name: "knees",
      shape: "rect ",
      coords: [104, 338, 135, 458],
      fillColor: "#6ec7d38e",
    },
    {
      name: "feets",
      shape: "rect ",
      coords: [99, 499, 70, 459],
      fillColor: "#6ec7d38e",
    },
    {
      name: "feets",
      shape: "rect ",
      coords: [105, 459, 136, 499],
      fillColor: "#6ec7d38e",
    },
    {
      name: "neck",
      shape: "rect ",
      coords: [59, 69, 137, 95],
      fillColor: "#6ec7d38e",
    },
    {
      name: "jaw",
      shape: "rect ",
      coords: [
        78, 54, 83, 66, 95, 71, 104, 69, 110, 63, 116, 53, 111, 52, 107, 59,
        101, 64, 90, 64, 82, 55,
      ],
      fillColor: "#6ec7d38e",
    },
    {
      name: "lips",
      shape: "rect ",
      coords: [88, 54, 104, 61],
      fillColor: "#6ec7d38e",
    },
    {
      name: "eyes",
      shape: "rect ",
      coords: [75, 33, 116, 41],
      fillColor: "#6ec7d38e",
    },
    {
      name: "nose",
      shape: "rect ",
      coords: [91, 35, 101, 51],
      fillColor: "#6ec7d38e",
    },
    {
      name: "ears",
      shape: "rect ",
      coords: [117, 36, 122, 52],
      fillColor: "#6ec7d38e",
    },
    {
      name: "ears",
      shape: "rect ",
      coords: [71, 36, 76, 53],
      fillColor: "#6ec7d38e",
    },
    {
      name: "forehead",
      shape: "rect ",
      coords: [74, 31, 117, 23],
      fillColor: "#6ec7d38e",
    },
    {
      name: "head",
      shape: "rect ",
      coords: [74, 21, 119, 6],
      fillColor: "#6ec7d38e",
    },
  ],
};

export const MAPFEMALEBACKMB = {
  name: "my-femaleBackmap",
  areas: [
    {
      name: "buttocks",
      shape: "rect ",
      coords: [48, 214, 145, 271],
      fillColor: "#6ec7d38e",
    },
    {
      name: "thigs",
      shape: "rect ",
      coords: [48, 214, 145, 271],
      fillColor: "#6ec7d38e",
    },
    {
      name: "thigs",
      shape: "rect ",
      coords: [97, 271, 143, 351],
      fillColor: "#6ec7d38e",
    },
    {
      name: "knees",
      shape: "rect ",
      coords: [61, 352, 93, 467],
      fillColor: "#6ec7d38e",
    },
    {
      name: "knees",
      shape: "rect ",
      coords: [101, 352, 131, 467],
      fillColor: "#6ec7d38e",
    },
    {
      name: "feets",
      shape: "rect ",
      coords: [64, 467, 92, 494],
      fillColor: "#6ec7d38e",
    },
    {
      name: "feets",
      shape: "rect ",
      coords: [100, 466, 127, 495],
      fillColor: "#6ec7d38e",
    },
    {
      name: "hands",
      shape: "rect ",
      coords: [60, 85, 16, 239],
      fillColor: "#6ec7d38e",
    },
    {
      name: "hands",
      shape: "rect ",
      coords: [129, 81, 177, 241],
      fillColor: "#6ec7d38e",
    },
    {
      name: "palms",
      shape: "rect ",
      coords: [129, 81, 177, 241],
      fillColor: "#6ec7d38e",
    },
    {
      name: "palms",
      shape: "rect ",
      coords: [159, 241, 189, 293],
      fillColor: "#6ec7d38e",
    },
    {
      name: "neck",
      shape: "rect ",
      coords: [67, 57, 125, 85],
      fillColor: "#6ec7d38e",
    },
    {
      name: "ears",
      shape: "rect ",
      coords: [115, 34, 120, 53],
      fillColor: "#6ec7d38e",
    },
    {
      name: "ears",
      shape: "rect ",
      coords: [75, 35, 70, 55],
      fillColor: "#6ec7d38e",
    },
    {
      name: "head",
      shape: "rect ",
      coords: [73, 27, 117, 4],
      fillColor: "#6ec7d38e",
    },
  ],
};
